import { render, staticRenderFns } from "./Item-ventas-perdidos.vue?vue&type=template&id=e8f3c0cc&scoped=true&lang=pug"
import script from "./Item-ventas-perdidos.vue?vue&type=script&lang=js"
export * from "./Item-ventas-perdidos.vue?vue&type=script&lang=js"
import style0 from "./Item-ventas-perdidos.vue?vue&type=style&index=0&id=e8f3c0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f3c0cc",
  null
  
)

export default component.exports